import {Notification, Message, MessageBox, Alert} from 'element-ui'

export default {
    NotificationModal(type, title, msg, duration) {
        Notification[type]({
            title: title,
            message: msg,
            duration: duration
        });
    },
    MessageModal(type, msg, time) {
        time = time || 4000
        Message[type]({
            message: msg,
            duration:time,
            showClose: true
        })
    },
    message(type, msg, time) {
        time = time || 4000
        Message[type]({
            message: msg,
            duration:time,
            showClose: true
        })
    },
    alert(msg, title, callSuccess){
        MessageBox.alert(msg,title,{dangerouslyUseHTMLString:true, showClose:false}).then(() => {
            if(callSuccess)  callSuccess();
        })
    },
    alert2(msg, title, callSuccess, timeout){
        let message = msg.replace('#time', timeout)
        MessageBox.alert(message,title,{dangerouslyUseHTMLString:true, showClose:false}).then(() => {
            if(callSuccess)  callSuccess();
        })
        let time = null;
        window.alert_msg = msg;
        let timeoutfunc = function (timeout, time) {
            window.alert_timeout = timeout;
            time = setTimeout(() =>{
                    let txt = document.querySelector(".el-message-box__message").children[0]
                    let tt=  (window.alert_timeout *60 -1) /60
                    Math.floor(tt* 100) / 100;
                    tt = tt.toFixed(2);
                    window.alert_timeout = tt
                    txt.innerHTML = window.alert_msg.replace('#time', tt)
                    timeoutfunc(tt, time)
            },1000)
            if(window.alert_timeout <= 0) clearTimeout(time)
        }
       if( msg.indexOf('#time') !== -1){
           timeoutfunc(timeout, time)
       }


    },
    confirm(msg, callSuccess, callCancel) {
        MessageBox.confirm(msg, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
        }).then(() => {
            callSuccess();
        }).catch(() => {
            if (callCancel) {
                callCancel();
            }
        })
    },
    ConfirmModal(msg, callSuccess, callCancel) {
        MessageBox.confirm(msg, '系统提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
        }).then(() => {
            callSuccess();
        }).catch(() => {
            if (callCancel) {
                callCancel();
            }
        })
    },
    ConfirmModal2(title,msg, callSuccess, callCancel) {
        MessageBox.confirm(msg, '系统提示：' + title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
        }).then(() => {
            callSuccess();
        }).catch(() => {
            if (callCancel) {
                callCancel();
            }
        })
    },
    hasSelectRows(selects) {
        if (selects.length < 1) {
            this.MessageModal('warning', '请先选择需要操作的列！');
            return false;
        } else {
            return true;
        }
    },
    compareArray(prop) {
        return function (obj1, obj2) {
            let val1 = obj1[prop];
            let val2 = obj2[prop];
            if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
                val1 = Number(val1);
                val2 = Number(val2);
            }
            if (val1 < val2) {
                return -1;
            } else if (val1 > val2) {
                return 1;
            } else {
                return 0;
            }
        }
    }, buildSelectOptions(labelKey, valueKey, array) {
        let options = [{label: '请选择', value: ''}];
        array.forEach(item => {
            options.push({
                label: item[labelKey],
                value: item[valueKey]
            });
        });
        return options;
    },
};


// WEBPACK FOOTER //
// ./src/config/tps.js